/**
 * @generated SignedSource<<703d661fb0bf434fcc8820f86166736e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectRelayWrapperV2_viewer$data = {
  readonly reportData: {
    readonly projects: {
      readonly pageInfo: {
        readonly endCursor: string | null;
        readonly hasNextPage: boolean;
      };
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly projectId: string;
          readonly companyProjectId: number | null;
          readonly customProjectId: string | null;
          readonly name: string | null;
          readonly projectColor: string | null;
          readonly readOnlyAccess: boolean | null;
          readonly taskTotals: {
            readonly work: {
              readonly estimate: {
                readonly minutes: number | null;
                readonly points: number | null;
              } | null;
              readonly remaining: {
                readonly minutes: number | null;
                readonly points: number | null;
              } | null;
            } | null;
            readonly reported: {
              readonly time: number | null;
              readonly points: number | null;
              readonly projected: number | null;
            } | null;
            readonly financial: {
              readonly revenue: {
                readonly planned: number | null;
                readonly actual: number | null;
              } | null;
              readonly billableActualMinutes: number | null;
              readonly nonBillableActualMinutes: number | null;
              readonly totalTimeAtCompletion: number | null;
              readonly billablePlannedTimeAndExpenses: number | null;
              readonly billableActualTimeAndExpenses: number | null;
              readonly billableForecastTimeAndExpensesToComplete: number | null;
              readonly billableTotalTimeAndExpensesAtCompletion: number | null;
              readonly totalForecastRevenueToComplete: number | null;
              readonly totalRevenueRecognition: number | null;
              readonly surplus: number | null;
            } | null;
            readonly entities: number | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentType": "ProjectRelayWrapperV2_viewer";
};
export type ProjectRelayWrapperV2_viewer$key = {
  readonly " $data"?: ProjectRelayWrapperV2_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectRelayWrapperV2_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "points",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "minutes",
    "storageKey": null
  },
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "pageSize"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "reportId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchQuery"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sharedId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "pageSize",
        "cursor": null,
        "direction": "forward",
        "path": [
          "reportData",
          "projects"
        ]
      }
    ]
  },
  "name": "ProjectRelayWrapperV2_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "reportId"
        },
        {
          "kind": "Variable",
          "name": "sharedId",
          "variableName": "sharedId"
        }
      ],
      "concreteType": "ReportData",
      "kind": "LinkedField",
      "name": "reportData",
      "plural": false,
      "selections": [
        {
          "alias": "projects",
          "args": [
            {
              "kind": "Variable",
              "name": "searchQuery",
              "variableName": "searchQuery"
            }
          ],
          "concreteType": "ReportProjectTypeConnection",
          "kind": "LinkedField",
          "name": "__TaskReport_projects_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ReportProjectTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ReportProject",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "projectId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyProjectId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "customProjectId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "projectColor",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "readOnlyAccess",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ReportTaskTotals",
                      "kind": "LinkedField",
                      "name": "taskTotals",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "TaskReportTableTask_GroupWork",
                          "kind": "LinkedField",
                          "name": "work",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "TaskReportTableTask_Unit",
                              "kind": "LinkedField",
                              "name": "estimate",
                              "plural": false,
                              "selections": (v1/*: any*/),
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "TaskReportTableTask_Unit",
                              "kind": "LinkedField",
                              "name": "remaining",
                              "plural": false,
                              "selections": (v1/*: any*/),
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "TaskReportTableTask_Reported",
                          "kind": "LinkedField",
                          "name": "reported",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "time",
                              "storageKey": null
                            },
                            (v0/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "projected",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ReportTotalsFinancial",
                          "kind": "LinkedField",
                          "name": "financial",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "TaskReportTableTask_Revenue",
                              "kind": "LinkedField",
                              "name": "revenue",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "planned",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "actual",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "billableActualMinutes",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "nonBillableActualMinutes",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "totalTimeAtCompletion",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "billablePlannedTimeAndExpenses",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "billableActualTimeAndExpenses",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "billableForecastTimeAndExpensesToComplete",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "billableTotalTimeAndExpensesAtCompletion",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "totalForecastRevenueToComplete",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "totalRevenueRecognition",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "surplus",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "entities",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "3121a8ef5e19a3b010d6e99ae2afc506";

export default node;
